module.exports = __webpack_public_path__ + "082e978dfc9f1609e66b63f323ef4c6f.svg";